import React, { useState, useEffect } from "react";
import { useNavigate,useParams, useLocation } from "react-router-dom";
import { api } from '../../api';
import Moment from "moment";

import { useQuery } from "../hooks/useQuery";
import DataTable from "react-data-table-component";
import { customStyles } from "../../styles/dataTableStyles";
import { useSelector,useDispatch } from "react-redux";
import { setSwitchRegion  } from "../../redux/authSlice";
import { decimalTo } from '../../utils/utils';

export default function OrdersTopup(props) {
  // eslint-disable-next-line 
  const today = new Date().toISOString().split("T")[0];
  // eslint-disable-next-line 
  const ref = React.useRef(null);
  const navigate = useNavigate();
  const query = useQuery();
  const location = useLocation(); 

  const token = useSelector((state) => state.auth.token);
  const dispatch = useDispatch();
  
  // eslint-disable-next-line 
  const [updateData, setUpdateData] = useState(false);
  const [orderList, setOrderList] = useState([]);
  // eslint-disable-next-line
  const [startDate, setStartDate] = useState('');
  // eslint-disable-next-line
  const [endDate, setEndDate] = useState('');
  // eslint-disable-next-line 
  const [reportStatus, setReportstatus] = useState(localStorage.getItem("status"));
  // eslint-disable-next-line 
  const [reportLoad, setReportLoad] = useState(false);
   // eslint-disable-next-line 
  const [updatedReports, setupdatedReports] = useState({});
  const { id, type, name } = useParams();
  const [pageSize, setPageSize] = useState(10); // Default page size
  const [page, setPage] = useState(1);
  const [totalRows, setTotalRows] = useState(0);

  // eslint-disable-next-line
  const [merchentId, setMerchantId] = useState(id);
  // eslint-disable-next-line
  const [productId, setProductId] = useState(id);
  // eslint-disable-next-line
  const [orderType, setOrderType] = useState(type);
  // eslint-disable-next-line
  const [date, setDate] = useState(localStorage.getItem("startDate"));
  // eslint-disable-next-line
  const [lastDate, setLastDate] = useState(localStorage.getItem("endDate"));
  // eslint-disable-next-line
  const [merchentName, setMerchentName] = useState('');


  const queryParams = new URLSearchParams(location.search);
  const transactionTypeParam = queryParams.get("transactionType");
  // eslint-disable-next-line
  const [transactionType, setTransactionType] = useState(transactionTypeParam);

 
  // eslint-disable-next-line
  const { id: mId } = useParams();
  // eslint-disable-next-line
  const isMerchantReport = query.get("reportInput") === 'merchent';
  const isSaleReport = query.get("reportInput") === 'sale';

  useEffect(() => {
    dispatch(setSwitchRegion(false));

    return () => {
        dispatch(setSwitchRegion(true)); // reset when unmounting
    };
    }, [dispatch]);

  
  useEffect(() => {
    
    handleClick();
    // eslint-disable-next-line
  }, [page,pageSize,token]);
  

  const columns = [
  {
    name: "S.No",
    selector: (row, index) => index + 1,
    cell: (row, index) => (
      <>
        <input type="hidden" value={row.merchentId} readOnly />
        <span>{row.pageCount || index + 1}</span>
      </>
    ),
    sortable: false,
  },
  {
    name: "Merchant",
    selector: row => row.merchent,
    cell: row => row.merchent ? <span className="add-ellip">{row.merchent}</span> : null,
    sortable: true,
  },
  {
    name: "Payment Date",
    selector: row => row.paymentDate,
    sortable: true,
  },
  {
    name: "Amount",
    selector: row => row.amount,
    cell: row => (
      row.amount !== undefined ? <span className="add-ellip">{decimalTo(row.amount).toFixed(2)}</span> : null
    ),
    sortable: true,
  },
  {
    name: "Mode",
    selector: row => row.mode,
    sortable: true,
  },
  {
    name: "Transaction No",
    selector: row => row.transactionNo,
    sortable: true,
  },
  {
    name: "Notes",
    selector: row => row.notes,
    cell: row => row.notes ? <span className="add-ellip">{row.notes}</span> : null,
  },
  {
    name: "Credit Available",
    selector: row => row.creditAvalable,
    cell: row => (
      row.creditAvalable !== undefined ? <span className="add-ellip">{decimalTo(row.creditAvalable).toFixed(2)}</span> : null
    ),
  },
  {
    name: "Transaction Type",
    selector: row => row.transactionType,
    cell: row => {
      if (row.transactionType === 'Debit') {
        return <span className="badge badge-danger">Debit</span>;
      } else {
        return <span className="badge badge-success">Credit</span>;
      }
    }
  }
];



// eslint-disable-next-line
  const handleClick = () => {
    const type = orderType;
    let formBody = {};

    if (type === "topup") {
    formBody = {
        type: type,
        startDate: date,
        endDate: lastDate,
        transactionType: transactionType,
        merchentId: merchentId,
        "pageSize": pageSize,
        "pageNo": page
    };
    api.reports
        .getReportsData(formBody,token)
        .then((res) => {
            if (res.success === true) {
                // setMerchentName(res.data.result[0].merchentName)
                 setOrderList(res.data.result);
                setupdatedReports(res.data.result);
                setTotalRows(res.data.totalCount);
                setUpdateData(true);
                setReportLoad(true);
            }
        })
        .catch((err) => console.log("error", err));
}
  };

  function handleDetail(row) {
    navigate(`/orders-details/${row}`);
  }

  // eslint-disable-next-line
  function handleView(e, rowId) {
    if (e) e.stopPropagation();
    navigate(`/orders-info/${rowId}`);
  }

  function handleGoback() {
    const strtDate = query.get("startDate");
    const endDate = query.get("endDate");
    const reportInput = query.get("reportInput");
    const statusTypeQuery = query.get("statusType");
    navigate(`/reports?startDate=${strtDate}&endDate=${endDate}&reportInput=${reportInput}${isSaleReport ? `&statusType=${statusTypeQuery}` : ''}`);
  }

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-sm-12">
          <div className="box-row">
            <div className="table-head">
              <h1 className="sec-header">
                {orderType !== "sales"
                  ? merchentName && <>Order Details of - {merchentName}</>
                  : <>Order Details {name}</>
                }
              </h1>
              <div className="row" style={{
                display: "flex",
                alignItems: "center",
                padding: "0px 15px",
                justifyContent: 'space-between'
              }}>
               
                <div className="form-group">
                  <button
                    type="button"
                    className="btn btn-primary mr-4"
                    style={{ borderRadius: "50%",float: "right" }}
                    onClick={handleGoback}
                  >
                    Back
                  </button>
                </div>
      <div className="form-group row col-md-8">
        <div className="col-md-3"><span><b>Merchant name</b>{' '}:</span></div>
        <div className="col-md-6"><span>{name}</span></div>
    </div>
    <div className="form-group row col-md-8">
        <div className="col-md-3"><span><b>Start Date</b>{' '}:</span></div>
        <div className="col-md-6"><span>{Moment(date).format("DD-MM-YYYY")}</span></div>
    </div>
    <div className="form-group row col-md-8">
        <div className="col-md-3"><span><b>End Date</b>{' '}:</span></div>
        <div className="col-md-6"><span>{Moment(lastDate).format("DD-MM-YYYY")}</span></div>
    </div>
    <div className="form-group row col-md-8">
        <div className="col-md-3"><span><b>Transaction Type</b>{' '}:</span></div>
        <div className="col-md-6"><span>{transactionType === '1' ? 'Debit' : transactionType === '2' ? 'Credit' : 'Credit & Debit'}</span></div>
    </div>



              </div>
            </div>
           
            <div className="card card-table">
              <div className="card-body gatepass-saveoutput">
                <div className="reports">
                  <DataTable
                    columns={columns}
                    data={orderList}
                    pagination
                    paginationServer
                    paginationTotalRows={totalRows}
                    paginationDefaultPage={page}
                    onChangePage={setPage}
                    onChangeRowsPerPage={(newPageSize, newPage) => {
                      setPageSize(newPageSize);
                      setPage(newPage); // Reset to selected page
                    }}
                    highlightOnHover
                    pointerOnHover
                    customStyles={customStyles}
                    onRowClicked={(row) => handleDetail(row.orderId)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
